import React from 'react';
import { Form, Button } from '@blueprintnyc/bpnyc-common';
import Editor from '@/components/Editor';
import EventGroupsPicker from '@/components/EventGroupsPicker';

const TextWidgetOptions = props => {
	const {
		widgetToUpdate,
		handleChange,
		widgetProps,
		onUpdate,
		theme,
		preview,
		event,
		handleGroupChange,
		targetKeys,
	} = props;

	return (
		<Form initialValues={widgetToUpdate.props} onChange={handleChange}>
			<div className="WidgetUpdateForm">
				<Form.Item label="Text Editor" name="text">
					<Editor theme={theme} widgetToUpdate={widgetToUpdate} preview={preview} />
				</Form.Item>
				<h4 className="admin-form-item-label">Group Permissions</h4>
				<div className="groups-picker">
					<EventGroupsPicker
						event={event}
						handleChange={handleGroupChange}
						targetKeys={targetKeys}
					/>
				</div>
			</div>
			<Button type="submit" style={{ marginTop: '15px' }} onClick={() => onUpdate(widgetProps)}>
				Submit
			</Button>
		</Form>
	);
};

export default TextWidgetOptions;
